import React, {useState} from 'react';
import styles from './Projects.module.css';
import EventImg from "assets/images/event-img.png";
import iconClasses from "assets/images/III.png";
import iconEducation from "assets/images/eduсation-icon.png";
import iconEvents from "assets/images/events-icon.png";
import iconGalaxy from "assets/images/galaxy-icon.png";
import AlbirPopup from 'components/AlbirPopup/AlbirPopup';
import { Link } from 'react-router-dom';
import { useTranslation,  Trans } from 'react-i18next';
import i18next from "i18next";

const Projects = () => {
const [isPopupOpen, setIsPopupOpen] = useState(false);
const openPopup = (e: React.MouseEvent) => {
  e.preventDefault();
  setIsPopupOpen(true);
};
const currentLang = i18next.language;

const { t } = useTranslation();

    return (
    <section className={styles['project-section']}>
        <div className={styles['heading-container']}>
            <h1 className={styles['heading']}>{t('ourProjects.heading')}</h1>
            <p  className={styles['project-p']}> <Trans i18nKey="ourProjects.slogan" components={{  br: <br />}} /> </p>
        </div>
        <div className={styles['project-content']}>
            <div className={styles['image-container']}>
                <img src={EventImg} alt="Event" className={styles['event-image']}/>
            </div>
            <ul className={styles['link-list']}>
                <li className={styles['link-item']}>
                    <Link to={`/${currentLang}/programs#course-pricing`} target="_blank" rel="noopener noreferrer" className={styles.card}>
                        <img src={iconClasses} alt="" className={styles.icon} />
                        <div className={styles.content}>
                            <h3>{t('ourProjects.project-title.0')}</h3>
                            <p>
                            <Trans i18nKey="ourProjects.project-text.0" components={{ highlight: <span/>, popupLink: <span onClick={openPopup} className={styles.popupLink} />}}/>
                            </p>
                        </div>
                    </Link>
                </li>
                <li className={styles['link-item']}>
                    <a href="#" target="_blank" rel="noopener noreferrer" className={styles.card}>
                        <img src={iconEducation} alt="" className={styles.icon} />
                        <div className={styles.content}>
                            <h3>{t('ourProjects.project-title.1')}</h3>
                            <p>
                            <Trans i18nKey="ourProjects.project-text.1" components={{  br: <br />, highlight: <span className={styles.highlight} />, popupLink: <span onClick={openPopup} className={styles.popupLink} />}}/>
                            </p>
                        </div>
                    </a>
                </li>
                <li className={styles['link-item']}>
                    <a href="https://t.me/+3jerWBKFeZ43OGQy/" target="_blank" rel="noopener noreferrer" className={styles.card}>
                        <img src={iconEvents} alt="" className={styles.icon} />
                        <div className={styles.content}>
                            <h3>{t('ourProjects.project-title.2')}</h3>
                            <p>
                            <Trans i18nKey="ourProjects.project-text.2" components={{ highlight: <span className={styles.highlight} />}}/>
                            </p>
                        </div>
                    </a>
                </li>
                <li className={styles['link-item']}>
                    <a href="https://t.me/+3jerWBKFeZ43OGQy" target="_blank" rel="noopener noreferrer" className={styles.card}>
                        <img src={iconGalaxy} alt="" className={styles.icon} />
                        <div className={styles.content}>
                            <h3>{t('ourProjects.project-title.3')}</h3>
                            <p>
                            <Trans i18nKey="ourProjects.project-text.3" components={{ highlight: <span className={styles.highlight} />}}/>
                            </p>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
        {isPopupOpen && <AlbirPopup onClose={() => setIsPopupOpen(false)} />}
    </section>
    );
};

export default Projects;